import { render } from "./CollectionsView.vue?vue&type=template&id=1cc3b9cb"
import script from "./CollectionsView.vue?vue&type=script&lang=js"
export * from "./CollectionsView.vue?vue&type=script&lang=js"

import "./CollectionsView.vue?vue&type=style&index=0&id=1cc3b9cb&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QTr,QTd,QTooltip,QInput,QIcon});
